var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-box"},[_c('img',{staticClass:"spinner-snake",attrs:{"src":_vm.imgUrl,"width":"30px"}}),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }